// React
import React from "react";

import "./Skill.scss";

const Skill = ({ name }) => {
  return <div className="skill">{name}</div>;
};

export default Skill;
